import * as React from 'react'
import * as Assets from '../../../Assets/Assets'
import { Main } from '../../../Logic/Main'
import { Logic } from '../../../Logic/Type'
import * as App from '../../../Logic/Database/app'
import * as Rest from '../../../Logic/Database/Rest'
import {Select} from './Reusables'
import {ModalConfirmation} from '../../Reusables/Modal'
import { RewardShopItemCheckout } from '../../../Logic/Index'
import {DateRangePicker} from 'react-dates'
import * as moment from 'moment'
import Swipe from 'react-easy-swipe'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {IconDefinition} from '@fortawesome/fontawesome-svg-core'
import {faTimes, faArrowDown, faArrowRight, faArrowUp, faArrowLeft, faFilter, faChevronLeft, faChevronRight, faExclamationTriangle, faTimesCircle} from '@fortawesome/free-solid-svg-icons'
class SwipeComponent extends React.Component<{C: number, slw: number, srw: number, sww: number, srh: number, rspopupbg: string, unlocks: boolean},{}> {
    render() {
      return (
        <Swipe
          onSwipeLeft={()=>PageChange(false)}
          onSwipeRight={()=>PageChange(true)}
        >
            {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.ChooseCategoryToEnter + Main.Instance.IndexState.default_language] ?
                <div className = "srs-right srs-right-category">
                    <div>
                        {this.props.C === 0 || Main.Instance.IndexState.startAnimation === true ?
                        <div className = "srs-right-wrapper box">
                            <div className = "waves" />
                            {Main.Instance.IndexState.startAnimation === false ? 
                            <span className = "srs-right-message">
                                {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.ChooseCategoryToEnter + Main.Instance.IndexState.default_language]}
                            </span> : 
                            this.props.C !== 0 && Main.Instance.IndexState.startAnimation ?
                            <span className = "srs-right-message">
                                {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.LoadingCargo + Main.Instance.IndexState.default_language] + '...'}
                            </span> :                             
                            void 0}
                        </div> : null}

                        {this.props.slw === this.props.srw && this.props.C === 0 && this.props.sww === this.props.slw ||
                        this.props.slw === this.props.srw && this.props.C !== 0 && this.props.sww === this.props.slw && 
                        Main.Instance.IndexState.startAnimation === true ? null :
                        <img
                            id = "image_right"
                            className = "img img-responsive srs-popup-bg"
                            src = {this.props.rspopupbg}
                        />}

                        {this.props.C !== 0 && Main.Instance.IndexState.PlayerLevel < Main.Instance.IndexState.minlevel[this.props.C - 1] && Main.Instance.IndexState.startAnimation === false ? 

                        <div className = "minlevel">
                            <div className = "minlevel1">&nbsp;</div>
                            <div className = "minlevel2" style = {{background: Assets.COLORS_5[Main.Instance.IndexState.minlevel[this.props.C - 1] - 1]}}>&nbsp;</div>
                            <span className = "minlevel3" style = {{fontSize: this.props.srh/17.4324324 + 'px'}}>
                                {/*Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.UnlocksAt + Main.Instance.IndexState.default_language].toUpperCase()*/
                                'UNLOCKS AT'
                                + ' ' + Main.Instance.IndexState.Levels[Main.Instance.IndexState.minlevel[this.props.C - 1] - 1]['name'].toUpperCase() + ' ' + 
                                Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Level + Main.Instance.IndexState.default_language].toUpperCase()}
                            </span>
                        </div>
                        : void 0}
                        {this.props.C === 0 || Main.Instance.IndexState.startAnimation === true || this.props.C !== 0 &&
                        Main.Instance.IndexState.PlayerLevel < Main.Instance.IndexState.minlevel[this.props.C - 1] ? null : 
                        ShopItems(this.props.C, this.props.srh, this.props.srw, this.props.unlocks)}
                    </div>
                </div>
            : void 0}
        </Swipe>
      );
    }
  }

function Cart_Buy(idx: number, category: number) {   
    let today = new Date()
    let date = today.toISOString().slice(0, 10)
    let time = today.toISOString().slice(11, 19)

    let bal: number = Main.Instance.IndexState.PointsXP

    let RewardShopCheckoutItems: RewardShopItemCheckout[]
    if (idx === undefined) {
        RewardShopCheckoutItems = Main.Instance.IndexState.RewardShopCheckoutItems
    } else {
        RewardShopCheckoutItems = []
        RewardShopCheckoutItems.push({
            name: Main.Instance.IndexState.shopItems[idx].title[0],
            price: Main.Instance.IndexState.shopItems[idx].discountedPrice.toString(),
            quantity: '1',
            value: Main.Instance.IndexState.shopItems[idx].discountedPrice.toString(),
            id: Main.Instance.IndexState.shopItems[idx].id.toString(),
            category: category.toString()
        })
    }

    for (let i: number = 0; i < RewardShopCheckoutItems.length; i++) {
        if (parseInt(RewardShopCheckoutItems[i].quantity) > 0) {
            let balAfter = bal - parseInt(RewardShopCheckoutItems[i].value)

            if (!Main.Instance.IndexState.shopItems[Main.Instance.ModalState.BuyWhat].multi) {
                for (const item of Main.Instance.IndexState.allPlayerRst) {
                    if (+item.idx === parseInt(RewardShopCheckoutItems[i].id)) {
                        // console.log ('already purchased')
                        return
                    }
                }
            }

            const allPlayerRst: any[] = Object.assign([], Main.Instance.IndexState.allPlayerRst)
            allPlayerRst.push({item_name: RewardShopCheckoutItems[i].name, idx: +RewardShopCheckoutItems[i].id, category: + RewardShopCheckoutItems[i].category})
            Logic.Type.New (Main.Instance.IndexState, {allPlayerRst})

            App.insertRewardShopTransaction(
                RewardShopCheckoutItems[i],
                date,
                time,
                bal.toString(),
                balAfter.toString())
            // bal = balAfter
        }
    }

    if (idx === undefined) {
        Logic.Type.New(Main.Instance.IndexState, {
            // PointsXP: bal,
            PointsXPCheckout: 0,
            ItemsCheckout: 0
        })
    } else {
        Logic.Type.New(Main.Instance.IndexState, {
            // PointsXP: bal,
        })
    }
}   

function ConfirmationLeave() {
    Logic.Type.New (Main.Instance.ModalState, {Confirmation: false})
    Logic.Type.New (Main.Instance.IndexState, {ALLOW_TRANSACTIONS: true})
}
function NoBalanceErrorLeave() {
    Logic.Type.New (Main.Instance.ModalState, {NoBalanceError: false})
}

function BuyItem(i: number, price: number) {
    if (Main.Instance.IndexState.ALLOW_TRANSACTIONS) {
        if (price <= Main.Instance.IndexState.PointsXP - Main.Instance.IndexState.PointsXPCheckout) {
            Logic.Type.New (Main.Instance.IndexState, {ALLOW_TRANSACTIONS: false})
            Logic.Type.New (Main.Instance.ModalState, {Confirmation: true, BuyWhat: i})
        } else {
            Logic.Type.New (Main.Instance.ModalState, {NoBalanceError: true, BuyWhat: i})        
        }
    }
}

function getTransactions() {
    Rest.filterRST(false)
}

function FirstPage() {
    Logic.Type.New(Main.Instance.IndexState, { pNum: 0, offset: (0).toString() })
    getTransactions()
}

function PrevPage() {
    if (Main.Instance.IndexState.pNum > 0) {

        Logic.Type.New(Main.Instance.IndexState, {
            offset: ((Main.Instance.IndexState.pNum - 1) *
                Main.Instance.IndexState.pSize).toString()
        })
        getTransactions()

        Logic.Type.New(Main.Instance.IndexState, { pNum: Main.Instance.IndexState.pNum - 1 })
    } else {
        LastPage()
    }
}

function NextPage() {
    if ((Main.Instance.IndexState.pNum + 1) * Main.Instance.IndexState.pSize < Main.Instance.IndexState.count) {

        Logic.Type.New(Main.Instance.IndexState, {
            offset: ((Main.Instance.IndexState.pNum + 1) *
                Main.Instance.IndexState.pSize).toString()
        })
        getTransactions()

        Logic.Type.New(Main.Instance.IndexState, { pNum: Main.Instance.IndexState.pNum + 1 })
    } else {
        FirstPage()
    }
}

function LastPage() {
    if (Main.Instance.IndexState.count <= Main.Instance.IndexState.pSize) {
        FirstPage()
    } else {
        let npNum: number = 0;

        if (Main.Instance.IndexState.count === 0) {
            Logic.Type.New(Main.Instance.IndexState, { offset: (0).toString() })
        } else {

            npNum = Math.trunc((Main.Instance.IndexState.count - 1) / Main.Instance.IndexState.pSize)
            Logic.Type.New(Main.Instance.IndexState, {
                offset: (npNum * Main.Instance.IndexState.pSize).toString()
            })
        }

        getTransactions()
        Logic.Type.New(Main.Instance.IndexState, { pNum: npNum })
    }
}

function getText(text: string, mt: boolean, main: boolean): JSX.Element[] {

    if (text === undefined || text.length === 0) return [<div key="0" />]
    let texts: JSX.Element[] = []
    let proceed: boolean = true
    let position: number = 1
    let startPosition: number = 0
    let endPosition: number = 0

    while (proceed) {

        let find: string = '/n'
        startPosition = position === 1 ? 0 : endPosition + 2
        if (startPosition === -1) break

        endPosition = text.indexOf(find, startPosition + 1)
        if (endPosition === -1) {
            endPosition = text.length
            proceed = false
        }

        texts.push(
            <div
                style = {mt && position > 1 ? { marginTop: '10px' } : {}}
                key = {startPosition.toString()}
                className = "info-content"
            >
                {text.substring(startPosition, endPosition)}
                {!main ? void 0 :
                <a 
                    style = {{marginLeft: '10px'}}
                    href = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Link + Main.Instance.IndexState.default_language]}
                    target = "_blank"
                >
                    {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.LinkText + Main.Instance.IndexState.default_language]}
                </a>
                }
            </div>
        )
        position++
    }
    return texts
}

function StopAnimation () {
    Logic.Type.New(Main.Instance.IndexState, {startAnimation: false})
}

function StopAnimationBalance () {
    Logic.Type.New(Main.Instance.IndexState, {startAnimationBalance: false})
}

function SC(which: number) {
    if (which + 1 !== Main.Instance.IndexState.Category)
    if (Main.Instance.IndexState.startAnimation === false) {
        Logic.Type.New(Main.Instance.IndexState, {Category: which + 1, startAnimation: true, page: 1})
        setTimeout(function() {StopAnimation()}, 2000);
    }
}

function StartAnimationBalance() {
    if (Main.Instance.IndexState.startAnimationBalance === false) {
        Logic.Type.New(Main.Instance.IndexState, {startAnimationBalance: true})
        Logic.Type.New(Main.Instance.ModalState, {Confirmation: false})
        setTimeout(function() {StopAnimationBalance()}, 1000);
    }
}

function getHovers (images: string[], s: string, category: string[]): JSX.Element[] {
    let hovers: JSX.Element[] = []
    for (let i: number = Assets.CategoriesAll + Assets.CategoriesStart - 1; i >= Assets.CategoriesStart; i--) {
        const post: string = Main.Instance.IndexState.Category === i + 1 - Assets.CategoriesStart ? ' visible' : ''
        const title: string = Main.Instance.IndexState.Category === i + 1 - Assets.CategoriesStart ? 
        Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Category + Main.Instance.IndexState.default_language] + ' ' + category[i+1-Assets.CategoriesStart] 
        + ' ' + 
        Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.isSelected + Main.Instance.IndexState.default_language] : s + category[i+1-Assets.CategoriesStart]
        hovers.push(
            <a key = {i.toString()} className = {'overlay-left-' + (i-Assets.CategoriesStart) + post} onClick = {() => SC(i - Assets.CategoriesStart)} title = {title}>
                <img src = {images[i]}/>
            </a>
        )
    }

    return hovers
}

function getScandibetShop(
    C: number/*,
    Password: string,
    PasswordIncorrect: boolean,
    Username: string,
    UsernameEmpty: boolean,
    PointsXP: number*/): JSX.Element {
    let slw: number
    let srw: number
    let srh: number
    
    let sww: number
    const image_left: Element = document.getElementById('image_left')
    if (image_left) {
        slw = image_left.clientWidth
    }

    const image_whole: Element = document.getElementById('image_whole')
    if (image_whole) {
        sww = image_whole.clientWidth
    }

    const image_right: Element = document.getElementById('image_right')
    if (image_right) {
        srw = image_right.clientWidth
        if (image_right.clientHeight > 0) {
            srh = image_right.clientHeight
        } else {
            srh = srw / 0.8    
        }
        // console.log ('srh' + srh)
    } else {
        srw = slw
        srh = srw / 0.8
    }

    let rs_popup_bg: string = ''
    if (Main.Instance.IndexState.images[Assets.ImageRight] !== undefined) rs_popup_bg = Main.Instance.IndexState.images[Assets.ImageRight]

    let tb_title: string = ''
    if (Main.Instance.IndexState.default_language !== undefined)
        tb_title = Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.ScandibetRewardShop + Main.Instance.IndexState.default_language]

    let tb_content: string = ''
    if (Main.Instance.IndexState.default_language !== undefined)
        tb_content = Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.WelcomeToTheShop + Main.Instance.IndexState.default_language]

    let category1: string = ''
    if (Main.Instance.IndexState.default_language !== undefined)
        category1 = Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.ChooseCategory + Main.Instance.IndexState.default_language]

    let category2: string = ''
    if (Main.Instance.IndexState.default_language !== undefined)
        category2 = Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.BuyRewardShopItem + Main.Instance.IndexState.default_language]

    let main_title: string = ''
    if (Main.Instance.IndexState.default_language !== undefined)
        main_title = Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.WhatYouCanBuy + Main.Instance.IndexState.default_language]
/*
    let rs_background: string = 
        Main.Instance.IndexState.custom.activeBlackFriday &&
        Main.Instance.IndexState.custom.blackFriday && Main.Instance.IndexState.custom.blackFriday.length > Assets.validImageFileLength ? Main.Instance.IndexState.custom.blackFriday :
        Main.Instance.IndexState.custom.activeChristmas &&
        Main.Instance.IndexState.custom.christmas && Main.Instance.IndexState.custom.christmas.length > Assets.validImageFileLength ? Main.Instance.IndexState.custom.christmas :    
        require ('../../../Assets/RewardShopSmall.png')
*/
    let rs_background: string = ''
    if (Main.Instance.IndexState.images[Assets.ImageLeft] !== undefined) rs_background = Main.Instance.IndexState.images[Assets.ImageLeft]
    let images: string[] = []
    if (Main.Instance.IndexState.images !== undefined) images = Main.Instance.IndexState.images
    let Category: string[] = []
    let category: string[] = []

    if (Main.Instance.IndexState.category !== undefined) Category = Main.Instance.IndexState.category

    if (Main.Instance.IndexState.default_language !== undefined)
        for (let i: number = 0; i < Category.length; i++) {
            if (i % Main.Instance.IndexState.languages.length === Main.Instance.IndexState.default_language) {
                category.push(Math.floor(i / Main.Instance.IndexState.languages.length) === 0 ? 'All categories' : Category[i])
            }
        }

    let unlocks = false
    if (C !== 0 && Main.Instance.IndexState.PlayerLevel < Main.Instance.IndexState.minlevel[C - 1] && Main.Instance.IndexState.startAnimation === false)
        unlocks = true

    return (
        <div id = "image_whole" className="srs clearfix">
            <div className = "srs-left">

                <div className="srs-left-top">
                    <div className="srs-left-top-title">
                        {Main.Instance.LoginState.Verified ?
                            <span
                                title = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.YourRewardPointsBalance + Main.Instance.IndexState.default_language]}
                                className = {Main.Instance.IndexState.startAnimationBalance === false ? 'balance1' :
                                        'balance1 animate'}
                                style = {{color: Main.Instance.IndexState.PointsXP == 0 ? 'red' : 'orange'}}
                            >
                                {Main.Instance.IndexState.PointsXP}&nbsp;
                                <small>{Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Coins + Main.Instance.IndexState.default_language]}</small>
                            </span>
                            : void 0}
                        {Main.Instance.LoginState.Verified ?
                            <span
                                title = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.YourRewardPointsBalance + Main.Instance.IndexState.default_language]}
                                className = "balance2"
                            >
                            {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Balance + Main.Instance.IndexState.default_language]+':'}
                            </span>
                            :
                            void 0
                            /*
                            <Input
                                tabIndex = {1}
                                type = "text"
                                placeholder = {Assets.Username}
                                val = {Username}
                                onChange = {(text) => Logic.Type.New(Main.Instance.LoginState, {Username: text})}
                                desc = {Assets.Username}
                                className = {UsernameEmpty ? 'incorrect-password user' : 'user'}
                            />*/
                        }
                        {Main.Instance.LoginState.Verified ?
                            <span className = "balance3">
                            {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.YourRewardPointsBalance + Main.Instance.IndexState.default_language] + ':'}
                            </span>
                            : void 0
                            /*
                            <Input
                                tabIndex = {1}
                                type = "text"
                                placeholder = {Assets.Username}
                                val = {Username}
                                onChange = {(text) => Logic.Type.New(Main.Instance.LoginState, {Username: text})}
                                desc = {Assets.Username}
                                className = {UsernameEmpty ? 'incorrect-password user' : 'user'}
                            />*/
                        }

                        {/*Main.Instance.LoginState.Verified ? null
                            :
                            <Input
                                tabIndex={2}
                                type="password"
                                placeholder={Assets.Password}
                                val={Password}
                                onChange={(text) => Logic.Type.New(Main.Instance.LoginState, { Password: text })}
                                desc={Assets.Password}
                                className={PasswordIncorrect ? 'incorrect-password pass' : 'pass'}
                            />
                        */}
                        {tb_title}
                    </div>
                    <div className="srs-left-top-content">{getText(tb_content, true, true)}</div>
                </div>
                <div className="srs-left-content">
                    <div className="srs-left-content-title">
                        {main_title}
                    </div>
                    {rs_background && rs_background.length > 0 ?
                        <div className="srs-left-content-image">
                            <img
                                id = "image_left"
                                className = "img img-responsive srs-background"
                                src = {rs_background}
                            />
{getHovers (images,  Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.ShowItemsInCategory + Main.Instance.IndexState.default_language] + ' ', category)}
                            {C !== 0 && Main.Instance.IndexState.startAnimation ? 
                            <div className = "srs-right-category-text animation">
                            {category[Main.Instance.IndexState.Category]}
                            &nbsp;
                            <FontAwesomeIcon className = "fatarrow" icon = {sww === slw ? faArrowDown : faArrowRight}/>
                            </div> :
                            C !== 0 && !Main.Instance.IndexState.startAnimation ?
                            <div className = "srs-right-category-text">
                            {category[Main.Instance.IndexState.Category]}
                            &nbsp;
                            <FontAwesomeIcon className = "fatArrow" icon = {sww === slw ? faArrowDown : faArrowRight}/>
                            </div> : null}
                        </div> : void 0}
                </div>
            </div>
            {/* RIGHT */}
            
            <div className="srs-right-top">
                <div className="srs-right-top-title">
                    {C !== 0 && Main.Instance.IndexState.startAnimation ?
                    Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.LoadingCargo + Main.Instance.IndexState.default_language] + '...' : 
                    C === 0 ? category1 : category2}
                </div>
            </div>
            <SwipeComponent C = {C} srw = {srw} slw = {slw} srh = {srh} sww = {sww} rspopupbg = {rs_popup_bg} unlocks = {unlocks}/>
        </div>
    )
}

function fullTable(rstItems: JSX.Element[]): JSX.Element {
    return (
        <table className="table table-hover table-responsive V1200 tableMarginTop">
            <thead>
                <tr>
                    <th title={Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.PurchaseID + Main.Instance.IndexState.default_language]}>
                        {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.PurchaseIDShort + Main.Instance.IndexState.default_language]}
                    </th>
                    <th style = {{ textAlign: 'center' }}>
                        {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Date + Main.Instance.IndexState.default_language]}&nbsp;<small>({Assets.UTC})</small>
                    </th>
                    <th style = {{ textAlign: 'center' }}>
                    {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Time + Main.Instance.IndexState.default_language]}&nbsp;
                    <small>({Assets.UTC})</small></th>
                    <th>{Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Category + Main.Instance.IndexState.default_language]}</th>
                    <th>{Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.ItemName + Main.Instance.IndexState.default_language]}</th>
                    <th 
                        title = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.BalanceBeforePurchase + Main.Instance.IndexState.default_language]}
                        style = {{ textAlign: 'right' }}
                    >
                        {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Before + Main.Instance.IndexState.default_language]}
                    </th>
                    <th 
                        title = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.BalanceAfterPurchase + Main.Instance.IndexState.default_language]}
                        style = {{ textAlign: 'right' }}
                    >
                        {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.After + Main.Instance.IndexState.default_language]}
                    </th>
                </tr>
            </thead>
            <tbody>
                {rstItems}
            </tbody>
        </table>
    )
}

function SelectUserItemValue (userItemValue: string) {
    let userCategoryValue: string = '0'
    for (const item of Main.Instance.IndexState.userItem) {
        if (item['id'] === parseInt(userItemValue, 10)) {
            userCategoryValue = item['category'].toString()
        }
    }
    Logic.Type.New(Main.Instance.IndexState, {userItemValue, userCategoryValue})
    Rest.filterRST(true)
}

function SelectUserCategoryValue (userCategoryValue: string) {
    let userItem: any[] = []
    for (const item of Main.Instance.IndexState.allPlayerRst) {
        if (item === undefined) continue
        let proceed: boolean = true
        for (const Item of userItem) {
            if (item.idx === Item.id) {
                proceed = false
                break
            }
        }
        if (proceed) {
            if (+userCategoryValue > 0) {
                if (item.category !== +userCategoryValue) proceed = false
            }

            if (proceed) userItem.push({id: item.idx, name: item.item_name, category: item.category})
        }
    }

    let userItemValue: string = '0'
    if (userItem.length === 1) userItemValue = userItem[0].id.toString()
    else userItem.sort(App.compare)

    Logic.Type.New(Main.Instance.IndexState, {userCategoryValue, userItemValue, userItem})
    Rest.filterRST(true)
}

function halfTable(rstItems: JSX.Element[]): JSX.Element {
    return (
        <table className="table table-hover table-responsive v1200 tableMarginTop">
            <thead>
                <tr>
                    <th title={Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.PurchaseID + Main.Instance.IndexState.default_language]}>
                        {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.PurchaseIDShort + Main.Instance.IndexState.default_language]}
                    </th>
                    <th style={{ textAlign: 'center' }}>
                        {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Date + Main.Instance.IndexState.default_language]}&nbsp;
                        <small>({Assets.UTC})</small>
                    </th>
                    <th style={{ textAlign: 'center' }}>
                        {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Time + Main.Instance.IndexState.default_language]}&nbsp;
                        <small>({Assets.UTC})</small>
                    </th>                    
                    <th title={Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.ItemName + Main.Instance.IndexState.default_language]}>
                        {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Item + Main.Instance.IndexState.default_language]}
                    </th>
                    <th
                        title = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Price + Main.Instance.IndexState.default_language]}
                        style = {{ textAlign: 'right' }}
                    >
                        {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Price + Main.Instance.IndexState.default_language]}
                    </th>
                </tr>
            </thead>
            <tbody>
                {rstItems}
            </tbody>
        </table>
    )
}

function RstTable(): JSX.Element {
    const customArrowIcon:JSX.Element = <FontAwesomeIcon icon = {faArrowRight} className = {Assets.reactDatesGreyColor}/>
    const customCloseIcon:JSX.Element = <FontAwesomeIcon icon = {faTimes} className = {Assets.reactDatesGreyColor}/>  
    let rstTable: JSX.Element = void 0
    let rstItems: JSX.Element[] = []
    let rstItemsHalf: JSX.Element[] = []
    let now: string = new Date().toISOString()
    let now_date: string = now.slice(0, 10)
    let tc: string = 'orangered'
    let tc0: string = 'red' 

    // if (!Main.Instance.IndexState.expand) {
    for (let i: number = 0; Main.Instance.IndexState.rstStream &&
        i < Main.Instance.IndexState.rstStream.length; i++) {
        let c: string = Main.Instance.IndexState.rstStream[i]['purchased_date'].slice(0,10) === now_date ? i === 0 ? tc0 : tc : '#333'
        let category_ = ''
        if (Main.Instance.IndexState.category && Main.Instance.IndexState.languages && Main.Instance.IndexState.default_language !== undefined) {
            category_ = Main.Instance.IndexState.category[Main.Instance.IndexState.rstStream[i]['category'] * Main.Instance.IndexState.languages.length + 
            Main.Instance.IndexState.default_language]
        }            
        rstItems.push(
        <tr key={i.toString()}>
            <td style={{color:c}}>{Main.Instance.IndexState.rstStream[i]['id']}</td>
            <td style={{color:c, textAlign: 'center' }}>
                {Main.Instance.IndexState.rstStream[i]['purchased_date'].slice(0, 10)}
            </td>
            <td style={{color:c,textAlign: 'center'}}>{Main.Instance.IndexState.rstStream[i]['purchased_time']}</td>
            <td style={{ color:c }}>{category_}</td>   
            <td style={{color:c}}>{Main.Instance.IndexState.rstStream[i]['item_name']}</td>
            {/*<td style={{color:c,textAlign: 'right' }}>{Main.Instance.IndexState.rstStream[i]['quantity']}</td>*/}
            <td style={{color:c,textAlign: 'right' }}>{Main.Instance.IndexState.rstStream[i]['price']}&nbsp;
            <small>{Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Coins + Main.Instance.IndexState.default_language].toLowerCase()}</small></td>
            {/*<td style={{color:c,textAlign: 'right' }}>{Main.Instance.IndexState.rstStream[i]['value']}</td>*/}
            <td style={{color:c,textAlign: 'right' }}>{Main.Instance.IndexState.rstStream[i]['balance_before']}&nbsp;
            <small>{Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Coins + Main.Instance.IndexState.default_language].toLowerCase()}</small></td>
            <td style={{color:c,textAlign: 'right' }}>{Main.Instance.IndexState.rstStream[i]['balance_after']}&nbsp;
                <small>{Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Coins + Main.Instance.IndexState.default_language].toLowerCase()}</small>
            </td>
        </tr>
        )
        let title: string = Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Quantity + Main.Instance.IndexState.default_language] + ': ' + 
            Main.Instance.IndexState.rstStream[i]['quantity'] + '\n' +
            Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Price + Main.Instance.IndexState.default_language]
            + ': ' + Main.Instance.IndexState.rstStream[i]['price'] + '\n' +
            Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.BalanceBeforePurchase + Main.Instance.IndexState.default_language]
                + ': ' + Main.Instance.IndexState.rstStream[i]['balance_before'] + '\n' +
            Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.BalanceAfterPurchase + Main.Instance.IndexState.default_language]
                + ': ' + Main.Instance.IndexState.rstStream[i]['balance_after']

        let category: string
        if (parseInt(Main.Instance.IndexState.userCategoryValue) === 0 && parseInt(Main.Instance.IndexState.userItemValue) === 0 && 
            Main.Instance.IndexState.category && Main.Instance.IndexState.languages && Main.Instance.IndexState.default_language !== undefined) {
            category = Main.Instance.IndexState.category[Main.Instance.IndexState.rstStream[i]['category'] * Main.Instance.IndexState.languages.length + 
            Main.Instance.IndexState.default_language]
        }
        rstItemsHalf.push(
        <tr key={i.toString()}>
            <td style={{color:c}} title={title}>{Main.Instance.IndexState.rstStream[i]['id']}</td>
            <td style={{color:c, textAlign: 'center'}}>
                {Main.Instance.IndexState.rstStream[i]['purchased_date'].slice(0, 10)}
            </td>
            <td style={{color:c,textAlign:'center'}}>{Main.Instance.IndexState.rstStream[i]['purchased_time']}</td>
            {category ? <td style={{color:c}}>{Main.Instance.IndexState.rstStream[i]['item_name'] + ' (' + category + ')'}</td> :
            <td style={{color:c}}>{Main.Instance.IndexState.rstStream[i]['item_name']}</td>}
            <td style={{color:c, textAlign: 'right' }}>{Main.Instance.IndexState.rstStream[i]['price']}&nbsp;
            <small>{Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Coins + Main.Instance.IndexState.default_language].toLowerCase()}</small></td>
        </tr>
        )
    }
/*
    } else {
        for (let i: number = 0; Main.Instance.IndexState.RstStream && i < Main.Instance.IndexState.RstStream.length; i++) {

            let category: string = ''
            if (Main.Instance.IndexState.category && Main.Instance.IndexState.languages && Main.Instance.IndexState.default_language !== undefined) {
                category = Main.Instance.IndexState.category[Main.Instance.IndexState.rstStream[i]['category'] * Main.Instance.IndexState.languages.length + 
                Main.Instance.IndexState.default_language]
            }

            rstItems.push(
                <tr key={i.toString()}>
                    {ExpandButton(
                        Main.Instance.IndexState.RstStream[i]['id'],
                        handleExpand,
                        Main.Instance.IndexState.Expand
                    )}
                    <td style={{ textAlign: 'left' }}>
                        {category}
                    </td>

                    <td style={{ textAlign: 'center' }}>
                        {Main.Instance.IndexState.RstStream[i]['purchased_date'].slice(0, 10)}
                    </td>
                    <td style={{ textAlign: 'center' }}>{Main.Instance.IndexState.RstStream[i]['purchased_time']}</td>
                    <td style={{ textAlign: 'right' }}>{Main.Instance.IndexState.RstStream[i]['avgprice']}&nbsp;
                    <small>{Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Coins + Main.Instance.IndexState.default_language].toLowerCase()}</small></td>
                    <td style={{ textAlign: 'right' }}>{Main.Instance.IndexState.RstStream[i]['balbefxp']}&nbsp;
                    <small>{Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Coins + Main.Instance.IndexState.default_language].toLowerCase()}</small></td>
                    <td style={{ textAlign: 'right' }}>{Main.Instance.IndexState.RstStream[i]['balaftxp']}&nbsp;
                    <small>{Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Coins + Main.Instance.IndexState.default_language].toLowerCase()}</small></td>
                </tr>
            )

            rstItemsHalf.push(
                <tr key={i.toString()}>
                    {ExpandButton(
                        Main.Instance.IndexState.RstStream[i]['id'],
                        handleExpand,
                        Main.Instance.IndexState.Expand
                    )}
                    <td style={{ textAlign: 'center' }}>
                        {Main.Instance.IndexState.RstStream[i]['purchased_date'].slice(0, 10)}
                    </td>
                    <td style={{ textAlign: 'center' }}>{Main.Instance.IndexState.RstStream[i]['purchased_time']}</td>
                    <td style={{ textAlign: 'right' }}>{Main.Instance.IndexState.RstStream[i]['valuexp']}</td>
                </tr>
            )

            let expanded = false
            for (let j = 0; j < Main.Instance.IndexState.Expand.length; j++) {
                if (parseInt(Main.Instance.IndexState.RstStream[i]['id']) == Main.Instance.IndexState.Expand[j]) {
                    expanded = true
                }
            }

            if (expanded) {
                for (let j: number = 0; j < Main.Instance.IndexState.RSTStream.length; j++) {
                    let Item = Main.Instance.IndexState.RSTStream[j]

                    if (Main.Instance.IndexState.RstStream[i]['purchased_date'].trim() !==
                        Item['purchased_date'].trim() ||
                        Main.Instance.IndexState.RstStream[i]['purchased_time'].trim() !==
                        Item['purchased_time'].trim()) {
                        continue
                    }

                    rstItems.push(
                        <tr key={i.toString() + '_' + j.toString()}>
                            <td style={{ textAlign: 'left' }}>{Item['id']}</td>
                            <td style={{ textAlign: 'left' }}>{Item['item_name']}</td>
                            <td style={{ textAlign: 'left' }}>{category}</td>                            
                            <td style={{ textAlign: 'center' }} colSpan={2}>{Assets._}</td>
                            <td style={{ textAlign: 'right' }}>{Item['price']}&nbsp;
                        <small>{Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Coins + Main.Instance.IndexState.default_language].toLowerCase()}</small></td>
                            <td style={{ textAlign: 'right' }}>{Item['balbefxp']}&nbsp;
                        <small>{Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Coins + Main.Instance.IndexState.default_language].toLowerCase()}</small></td>
                            <td style={{ textAlign: 'right' }}>{Item['balaftxp']}&nbsp;
                            <small>{Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Coins + Main.Instance.IndexState.default_language].toLowerCase()}</small>
                            </td>
                        </tr>)
                    let title: string = Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Quantity + Main.Instance.IndexState.default_language] +
                    ': ' + Item['quantity'] + '\n' +
                    Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Price + Main.Instance.IndexState.default_language]
                    + ': ' + Main.Instance.IndexState.rstStream[i]['price'] + '\n' +
                    Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.BalanceBeforePurchase + Main.Instance.IndexState.default_language]
                    + ': ' + Item['balbefxp'] + '\n' +
                    Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.BalanceAfterPurchase + Main.Instance.IndexState.default_language]
                    + ': ' + Item['balaftxp']

                    rstItemsHalf.push(
                        <tr key={i.toString() + '_' + j.toString()}>
                            <td title={title} style={{ textAlign: 'left' }}>{Item['id']}</td>
                            <td style={{ textAlign: 'left' }}>{Item['item_name']}</td>
                            <td style={{ textAlign: 'center' }} colSpan={2}>{Assets._}</td>
                            <td style={{ textAlign: 'right' }}>{Item['price']}</td>
                        </tr>)
                }
            }
        }
    }
    */
    rstTable = <div>
        <div className="my-transactions-history">
            {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.MyTransactionsHistory + Main.Instance.IndexState.default_language]}
        </div>
        <div className="control-panel v1200">
            <div className="clearfix">
                <button
                    className="btn btn-primary btn-default btn-xs"
                    style={{ paddingTop: '3px', marginTop: '4px'}}
                    title={Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.ListMoveTop + Main.Instance.IndexState.default_language]}
                    onClick={() => FirstPage()}
                >
                    <FontAwesomeIcon icon = {faArrowUp}/>
                </button>
                <button
                    className="btn btn-primary btn-default btn-xs"
                    style={{ paddingTop: '3px', marginTop: '4px', marginLeft: '5px' }}
                    title={Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.ListMovePrevious + Main.Instance.IndexState.default_language]}
                    onClick={() => PrevPage()}
                >
                    <FontAwesomeIcon icon = {faArrowLeft}/>
                </button>
                <button
                    className="btn btn-primary btn-default btn-xs"
                    style={{ paddingTop: '3px', marginTop: '4px', marginLeft: '5px' }}
                    title={Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.ListMoveNext + Main.Instance.IndexState.default_language]}
                    onClick={() => NextPage()}
                >
                    <FontAwesomeIcon icon = {faArrowRight}/>
                </button>
                <button
                    className="btn btn-primary btn-default btn-xs"
                    style={{ paddingTop: '3px', marginTop: '4px', marginLeft: '5px' }}
                    title={Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.ListMoveBottom + Main.Instance.IndexState.default_language]}
                    onClick={() => LastPage()}
                >
                    <FontAwesomeIcon icon = {faArrowDown}/>
                </button>

                <span style={{fontWeight: 900,margin:'4px 5px 0px 0px'}}className="label label-primary table-label fr">
                    {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.recordsShort + Main.Instance.IndexState.default_language] + ': '}
                    {Main.Instance.IndexState.count ? Main.Instance.IndexState.count : 0}
                </span>

                <span 
                    style={{fontWeight:900,margin:'4px 5px 0px 0px'}}
                    className="label label-primary table-label fr"
                    title ={Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.showing + Main.Instance.IndexState.default_language]}
                >
                    {Main.Instance.IndexState.count ? Main.Instance.IndexState.pNum * Main.Instance.IndexState.pSize + 1 : 0}{' - '}
                    {Main.Instance.IndexState.count ?
                        (Main.Instance.IndexState.pNum + 1) * Main.Instance.IndexState.count ?
                        Main.Instance.IndexState.count :
                        (Main.Instance.IndexState.pNum + 1) * Main.Instance.IndexState.pSize : 0}
                </span>

                <span
                    title= {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.page + Main.Instance.IndexState.default_language]}
                    style={{fontWeight:900,margin:'4px 10px 0px 0px'}}
                    className="label label-primary table-label fr"
                >
                    {Main.Instance.IndexState.count ? Main.Instance.IndexState.pNum + 1 : 0}{' / '}
                    {Main.Instance.IndexState.count ? Math.trunc((Main.Instance.IndexState.count - 1) / Main.Instance.IndexState.pSize + 1) : 0}
                </span>
            </div>
            <div>
                <div 
                    title = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.FilterByDate + Main.Instance.IndexState.default_language]}
                    className = "fl mr visible-s"
                >
                    <span className = "mt4 dibl input-group-addon redBG">
                        <FontAwesomeIcon icon = {faFilter}/>
                    </span>
                    <DateRangePicker
                        startDatePlaceholderText = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.StartDate + Main.Instance.IndexState.default_language]}
                        endDatePlaceholderText = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.EndDate + Main.Instance.IndexState.default_language]}
                        startDateId = "startDateId"
                        endDateId = "endDateId"
                        startDate = {Main.Instance.IndexState.from_date}
                        endDate = {Main.Instance.IndexState.to_date}
                        onDatesChange = {({startDate, endDate}) => DatesChange(startDate, endDate)}
                        focusedInput = {Main.Instance.IndexState.focusedInput2}
                        onFocusChange = {
                            focusedInput => Logic.Type.New(Main.Instance.IndexState, {focusedInput2:focusedInput})}
                        showDefaultInputIcon = {true}
                        showClearDates = {true}
                        isOutsideRange = {() => false}
                        displayFormat = {Assets.dateFormatDisplay}
                        customArrowIcon = {customArrowIcon}
                        customCloseIcon = {customCloseIcon}
                        minimumNights = {0}
                        numberOfMonths={1}
                    />
                </div>
                <div 
                    title = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.FilterByDate + Main.Instance.IndexState.default_language]}
                    className = "fl mr hidden-s"
                >
                    <span className = "mt4 dibl input-group-addon redBG">
                        <FontAwesomeIcon icon = {faFilter}/>
                    </span>
                    <DateRangePicker
                        startDatePlaceholderText = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.StartDate + Main.Instance.IndexState.default_language]}
                        endDatePlaceholderText = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.EndDate + Main.Instance.IndexState.default_language]}
                        startDateId = "startDateId"
                        endDateId = "endDateId"
                        startDate = {Main.Instance.IndexState.from_date}
                        endDate = {Main.Instance.IndexState.to_date}
                        onDatesChange = {({startDate, endDate}) => DatesChange(startDate, endDate)}
                        focusedInput = {Main.Instance.IndexState.focusedInput3}
                        onFocusChange = {
                            focusedInput => Logic.Type.New(Main.Instance.IndexState, {focusedInput3:focusedInput})}
                        showDefaultInputIcon = {true}
                        showClearDates = {true}
                        isOutsideRange = {() => false}
                        displayFormat = {Assets.dateFormatDisplay}
                        customArrowIcon = {customArrowIcon}
                        customCloseIcon = {customCloseIcon}
                        minimumNights = {0}
                        numberOfMonths={1}
                    />
                </div>
                <Select
                    classname = "fl dbl mt4 SelectClassName"
                    spanClassname = "orangeBG"
                    data = {Main.Instance.IndexState.userCategory}
                    value = {Main.Instance.IndexState.userCategoryValue}
                    icon = {faFilter as IconDefinition}
                    // size = "lg"
                    onChange = {userCategoryValue => SelectUserCategoryValue(userCategoryValue)}
                    description = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.FilterByCategory + Main.Instance.IndexState.default_language]}
                    title = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.AnyCategory + Main.Instance.IndexState.default_language]}
                    selectClassName = "selectClassName"
                />

                <Select
                    classname = "fl dbl mt4 SelectClassName"
                    spanClassname = "yellowBG"
                    data = {Main.Instance.IndexState.userItem}
                    value = {Main.Instance.IndexState.userItemValue}
                    icon = {faFilter as IconDefinition}
                    // size = "lg"
                    onChange = {userItemValue => SelectUserItemValue (userItemValue)}
                    description = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.FilterByItem + Main.Instance.IndexState.default_language]}
                    title = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.AnyItem + Main.Instance.IndexState.default_language]}
                    selectClassName = "selectClassName"
                />
            </div>
        </div>
        <div className="control-panel V1200">
            <button
                className="btn btn-primary btn-default btn-xs fl dbl"
                style={{ paddingTop: '3px', marginTop: '4px'}}
                title={Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.ListMoveTop + Main.Instance.IndexState.default_language]}
                onClick={() => FirstPage()}
            >
                <FontAwesomeIcon icon = {faArrowUp}/>
            </button>
            <button
                className="btn btn-primary btn-default btn-xs fl dbl"
                style={{ paddingTop: '3px', marginTop: '4px' }}
                title={Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.ListMovePrevious + Main.Instance.IndexState.default_language]}
                onClick={() => PrevPage()}
            >
                <FontAwesomeIcon icon = {faArrowLeft}/>
            </button>
            <button
                className="btn btn-primary btn-default btn-xs fl dbl"
                style={{ paddingTop: '3px', marginTop: '4px' }}
                title={Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.ListMoveNext + Main.Instance.IndexState.default_language]}
                onClick={() => NextPage()}
            >
                <FontAwesomeIcon icon = {faArrowRight}/>
            </button>
            <button
                className="btn btn-primary btn-default btn-xs fl dbl"
                style={{ paddingTop: '3px', marginTop: '4px' }}
                title={Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.ListMoveBottom + Main.Instance.IndexState.default_language]}
                onClick={() => LastPage()}
            >
                <FontAwesomeIcon icon = {faArrowDown}/>
            </button>
            <div 
                title = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.FilterByDate + Main.Instance.IndexState.default_language]}
                className = "fl mr"
                style = {{marginLeft: '10px'}}
            >
                <span className = "mt4 dibl input-group-addon redBG">
                    <FontAwesomeIcon icon = {faFilter}/>
                </span>
                <DateRangePicker
                    startDatePlaceholderText = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.StartDate + Main.Instance.IndexState.default_language]}
                    endDatePlaceholderText = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.EndDate + Main.Instance.IndexState.default_language]}
                    startDateId = "startDateId"
                    endDateId = "endDateId"
                    startDate = {Main.Instance.IndexState.from_date} 
                    endDate = {Main.Instance.IndexState.to_date}
                    onDatesChange = {({startDate, endDate}) => DatesChange(startDate, endDate)}
                    focusedInput = {Main.Instance.IndexState.focusedInput}
                    onFocusChange = {
                        focusedInput => Logic.Type.New(Main.Instance.IndexState, {focusedInput:focusedInput})}
                    showDefaultInputIcon = {true}
                    showClearDates = {true}
                    isOutsideRange = {() => false}
                    displayFormat = {Assets.dateFormatDisplay}
                    customArrowIcon = {customArrowIcon}
                    customCloseIcon = {customCloseIcon}
                    minimumNights = {0}
                    numberOfMonths = {1}
                />
            </div>

            <Select
                classname = "fl dbl mt4 SelectClassName"
                spanClassname = "orangeBG"
                data = {Main.Instance.IndexState.userCategory}
                value = {Main.Instance.IndexState.userCategoryValue}
                icon = {faFilter as IconDefinition}
                // size = "lg"
                onChange = {userCategoryValue => SelectUserCategoryValue(userCategoryValue)}
                description = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.FilterByCategory + Main.Instance.IndexState.default_language]}
                title = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.AnyCategory + Main.Instance.IndexState.default_language]}
                selectClassName = "selectClassName"
            />

            <Select
                classname = "fl dbl mt4 SelectClassName"
                spanClassname = "yellowBG"
                data = {Main.Instance.IndexState.userItem}
                value = {Main.Instance.IndexState.userItemValue}
                icon = {faFilter as IconDefinition}
                // size = "lg"
                onChange = {userItemValue => SelectUserItemValue(userItemValue)}
                description = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.FilterByItem + Main.Instance.IndexState.default_language]}
                title = {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.AnyItem + Main.Instance.IndexState.default_language]}
                selectClassName = "selectClassName"
            />

            <span style={{ fontWeight: 900, margin: '4px 15px 0px 0px' }} className="label label-primary table-label">
                {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.records + Main.Instance.IndexState.default_language] + ': '}
                {Main.Instance.IndexState.count ? Main.Instance.IndexState.count : 0}
            </span>

            <span style={{ fontWeight: 900, margin: '4px 10px 0px 0px' }} className="label label-primary table-label">
                {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.showing + Main.Instance.IndexState.default_language] + ': '}
                {Main.Instance.IndexState.count ? Main.Instance.IndexState.pNum * Main.Instance.IndexState.pSize + 1 : 0}{' - '}
                {Main.Instance.IndexState.count ?
                ((Main.Instance.IndexState.pNum + 1) * Main.Instance.IndexState.pSize >
                Main.Instance.IndexState.count ?
                Main.Instance.IndexState.count :
                (Main.Instance.IndexState.pNum + 1) * Main.Instance.IndexState.pSize) : 0}
            </span>

            <span style={{ fontWeight: 900, margin: '4px 10px 0px 0px' }} className="label label-primary table-label">
                {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.page + Main.Instance.IndexState.default_language] + ': '}
                {Main.Instance.IndexState.count ? Main.Instance.IndexState.pNum + 1 : 0}{' / '}
                {Main.Instance.IndexState.count ? Math.trunc((Main.Instance.IndexState.count - 1)/ Main.Instance.IndexState.pSize + 1) : 0}
            </span>
        </div>
        <br/>
        {fullTable(rstItems)}
        {halfTable(rstItemsHalf)}
    </div>
    //    }
    return rstTable
}

function DatesChange (startDate: moment.Moment, endDate: moment.Moment) {
    Logic.Type.New(Main.Instance.IndexState, {from_date: startDate, to_date: endDate})
    getTransactions()
}

export function Toggle (mode: boolean, which: number) {
    if (mode) {
        let Info: boolean[] = Object.assign ([], Main.Instance.IndexState.Info)
        let oldValue: boolean = Info[which]

        for (let i: number = 0; i < Info.length; i++) {
            if (i === which) Info[i] = !oldValue
            else if (oldValue === false) {
                Info[i] = false
            }
        }
        
        Logic.Type.New (Main.Instance.IndexState, {Info})
    }
}

function ToggleInfo () {
    Logic.Type.New (Main.Instance.IndexState, {InfoConfirm: !Main.Instance.IndexState.InfoConfirm})
}

function ToggleInfo2 () {
    Logic.Type.New (Main.Instance.IndexState, {InfoConfirm2: !Main.Instance.IndexState.InfoConfirm2})
}

function SetInfoConfirmFalse() {
    Logic.Type.New (Main.Instance.IndexState, {InfoConfirm: false})
}

function SetInfoConfirm2False() {
    Logic.Type.New (Main.Instance.IndexState, {InfoConfirm2: false})
}

function ShopItems(Category: number, srh: number, srw: number, unlocks: boolean): JSX.Element[] {
    const shopItems: JSX.Element[] = []
    const factorWidth: number = srw / Main.Instance.IndexState.W
    const factorHeight: number = srh / Main.Instance.IndexState.H

    const center = Main.Instance.IndexState.center * factorWidth
    const centerTop = Main.Instance.IndexState.centerTop * factorHeight
    const centerBottom = Main.Instance.IndexState.centerBottom * factorHeight
    const left: number = Main.Instance.IndexState.left * factorWidth
    const Right: number = Main.Instance.IndexState.right * factorWidth
    const right: number = srw - Right

    const top: number = Main.Instance.IndexState.top * factorHeight
    const bottom: number = Main.Instance.IndexState.bottom * factorHeight
    // console.log (Main.Instance.IndexState.box)
    const box_width: number = Main.Instance.IndexState.box * factorWidth
    const box_height: number = Main.Instance.IndexState.box * factorHeight

    const vertical_space: number = (bottom - top - 4 * box_height) / 3

    const cols: number = 2

    let count: number = -1
    let countTotal: number = 0

    // const newdate = new Date()
    // tslint:disable-next-line:max-line-length
    // const UTC: Date = new Date(newdate.getUTCFullYear(), newdate.getUTCMonth(), newdate.getUTCDate(), newdate.getUTCHours(), newdate.getUTCMinutes(), newdate.getUTCSeconds(), newdate.getUTCMilliseconds())
    const utc: string = (new Date()).toISOString()
    // const utcDate: string = utc.substring(0,10)
    const utcTime: string = utc.substring(11,19)
    const UTC: string = utc.substring(0,10) + utcTime
    // console.log (utcDate, utcTime)
    // console.log (utcDate)
    // console.log (UTC) 
    // console.log (Main.Instance.IndexState.shopItems)

    for (let i = 0; i < Main.Instance.IndexState.shopItems.length; i++) {
        if (Main.Instance.IndexState.shopItems[i].players !== undefined && Main.Instance.IndexState.shopItems[i].players !== null && Main.Instance.IndexState.shopItems[i].players.length > 0) {
            let Proceed: boolean = false
            for (const item of Main.Instance.IndexState.shopItems[i].players) if (item === Main.Instance.IndexState.PLAYERID) {Proceed = true; break}
            if (Proceed === false) continue
        }
        if (Category === undefined || Category === 0 || Main.Instance.IndexState.shopItems[i].category !== Category) continue

        if ((Main.Instance.IndexState.shopItems[i].active === false || Main.Instance.IndexState.shopItems[i].index === -1) && 
            (Main.Instance.IndexState.PLAYERID !== 1036263 || Main.Instance.IndexState.ACT_AS_CUSTOMER)
            && Main.Instance.IndexState.PLAYERID !== 618701 && Main.Instance.IndexState.PLAYERID !== 618718) continue

        // tslint:disable-next-line:max-line-length
        const fromDate: string = Main.Instance.IndexState.shopItems[i].fromtime !== null && Main.Instance.IndexState.shopItems[i].fromtime.substring(0, 10) !== '1970-01-01' ? Main.Instance.IndexState.shopItems[i].fromtime.substring(0, 10) : undefined
        const fromTime: string = Main.Instance.IndexState.shopItems[i].fromtime !== null ? Main.Instance.IndexState.shopItems[i].fromtime.substring(11, 19) : undefined
        // tslint:disable-next-line:max-line-length
        const toDate: string = Main.Instance.IndexState.shopItems[i].totime !== null && Main.Instance.IndexState.shopItems[i].totime.substring(0, 10) !== '1970-01-01' ? Main.Instance.IndexState.shopItems[i].totime.substring(0, 10) : undefined
        const toTime: string = Main.Instance.IndexState.shopItems[i].totime !== null ? Main.Instance.IndexState.shopItems[i].totime.substring(11, 19) : undefined
        if (fromDate || fromTime || toDate || toTime) {
            // console.log (fromDate, fromTime, toDate, toTime)
            if (fromDate === undefined && toDate === undefined && !(fromTime === '00:00:00' && toTime === '00:00:00')) { // ONLY COMPARE TIMES
                if (utcTime < fromTime || utcTime >= toTime) {
                    // console.log ('CONTINUE - TIME!', fromDate, fromTime, toDate, toTime)
                    continue
                }
            } else if (fromDate !== undefined && toDate !== undefined) {
                if (UTC < fromDate + fromTime || UTC >= toDate + toTime) {
                    // console.log ('CONTINUE - BOTH DATES SET!', fromDate, fromTime, toDate, toTime)
                    continue
                }
            } else if (fromDate === undefined) {
                if (UTC >= toDate + toTime) {
                    // console.log ('CONTINUE - DATE END SET!', fromDate, fromTime, toDate, toTime)
                    continue
                }
            } else if (toDate === undefined) {
                if (UTC < fromDate + fromTime) {
                    // console.log ('CONTINUE - DATE START SET!', fromDate, fromTime, toDate, toTime)
                    continue
                }
            }
            // console.log ('PUBLISHED', fromDate, fromTime, toDate, toTime)
        }

        let proceed: boolean = true
        if (Main.Instance.IndexState.shopItems[i].multi.toString() === 'false' && Main.Instance.IndexState.allPlayerRst)
        for (const item of Main.Instance.IndexState.allPlayerRst) {
            if (item && item.idx === +Main.Instance.IndexState.shopItems[i].id) {
                proceed = false
                break
            }
        }

        if (proceed === false) continue
        if (Main.Instance.IndexState.shopItems[i].newly.toString() === 'true' && 
        (Main.Instance.IndexState.PlayerLevel > Assets.NewPlayerMaxLevel || Main.Instance.IndexState.PlayerSubLevel > Assets.NewPlayerMaxSublevel)) continue
       
        countTotal++
        if (countTotal <= (Main.Instance.IndexState.page - 1) * Assets.Items) continue
        if (countTotal > Main.Instance.IndexState.page * Assets.Items) continue
        count++

        const price: number = Math.round(Main.Instance.IndexState.shopItems[i].price *
            (1 - Main.Instance.IndexState.shopItems[i].discount / 100))

        const coverWhole: boolean = Main.Instance.IndexState.cover_whole

        // verified
        const verified: boolean = Main.Instance.LoginState.Verified // Main.Instance.IndexState.PointsXP !== undefined

        // can we afford it? TRUE - WE CAN, FALSE - WE CANNOT
        const balance: boolean = price <= Main.Instance.IndexState.PointsXP - Main.Instance.IndexState.PointsXPCheckout

        // let bottom: number = parseInt(Main.Instance.IndexState.shop_item_height) -
            // parseInt(Main.Instance.IndexState.shop_item_image_height)
        // is it free round
        // let f: boolean = Main.Instance.IndexState.shopItems[i].free_round
        const row: number = Math.floor((count - 1) / cols)
        const col: number = (count - 1) % cols
        const Top: number = top + row * (box_height + vertical_space)

        const active: string = Main.Instance.IndexState.Info[count] ? ' Active' : ''

        shopItems.push(
            <div
                key = {(2 * i).toString()}
                className = {'Shop-item ' + active}
                style = {{
                    height: box_height + 'px',
                    width: box_width + 'px',
                    border: '0px',
                    left: count === 0 || count === Assets.Items - 1 ? center + 'px' : col === 0 ? left + 'px' : 'auto',
                    right: count === 0 ? 'auto' : col === 1 ? right + 'px' : 'auto',
                    top: count === 0 ? centerTop + 'px' : count === Assets.Items - 1 ? centerBottom + 'px' : Top + 'px',
                    borderRadius: Main.Instance.IndexState.border_radius
                }}
            >
                <div
                    style = {{
                        cursor: 'pointer',
                        height: '100%',
                        width: '100%',
                        borderRadius: Main.Instance.IndexState.border_radius
                    }}

                    className = "shop-item"
                    onClick = {() => BuyItem(i, price)}
                    
                >
                    {coverWhole ?
                        <img
                            style = {{
                                height: '100%',
                                width: '100%',
                                borderRadius: Main.Instance.IndexState.border_radius,
                            }}
                            src = {Main.Instance.IndexState.shopItems[i].image}
                            className = "img-responsive shop-item-image"
                        />
                        :
                        <img
                            style = {{
                                height: box_height,
                                width: box_width,
                                borderRadius: Main.Instance.IndexState.border_radius,
                            }}
                            src = {Main.Instance.IndexState.shopItems[i].image}
                            className = "img-responsive shop-item-image"
                        />
                    }

                    {coverWhole ?
                        <img
                            style = {{
                                height: '100%',
                                width: '100%',
                                borderRadius: Main.Instance.IndexState.border_radius,
                            }}
                            src = {Main.Instance.IndexState.shopItems[i].image}
                            className = "img-responsive shop-item-image shop-item-image-hover darken"
                        />
                        :
                        <img
                            style = {{
                                height: box_height,
                                width: box_width,
                                borderRadius: Main.Instance.IndexState.border_radius,
                            }}
                            src = {Main.Instance.IndexState.shopItems[i].image}
                            className = "img-responsive shop-item-image shop-item-image-hover darken"
                        />
                    }

                    {balance ?
                        <span
                            className = "shop-item-filter"
                            style = {{
                                top: '0px',
                                bottom: coverWhole ? '0px' : (bottom).toString() + 'px',
                                borderRadius: Main.Instance.IndexState.border_radius,
                                border: '0px'
                            }}
                        /> : void 0}


                    {verified && !balance ?
                        <span
                            className = "shop-item-filter-unaffordable"
                            style = {{
                                top: '0px',
                                bottom: coverWhole ? '0px' : (bottom).toString() + 'px',
                                borderRadius: Main.Instance.IndexState.border_radius,
                                border: '0px'
                            }}
                        /> : void 0}

                    {Main.Instance.IndexState.border.startsWith('0px') ? void 0 :
                    <div
                        style = {{
                            position: 'absolute',
                            borderRadius: 'inherit',
                            border: Main.Instance.IndexState.border,
                            height: '100%',
                            width: '100%',
                            zIndex: 9899
                        }}
                    >&nbsp;
                    </div>}
                </div>
            </div>)

        shopItems.push (
            <div key = {(2 * i + 1).toString()} className = "srs-right-info-box">
                <div className = {Main.Instance.IndexState.shopItems[i].discount > 0 ? 'info-price info-price-discount' : 'info-price'}>
                    {Main.Instance.IndexState.shopItems[i].discountedPrice !== undefined ? Main.Instance.IndexState.shopItems[i].discountedPrice : null}
                    <span className = "info-price-price">
                        {Main.Instance.IndexState.shopItems[i].discount > 0 ? 
                        Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Price + Main.Instance.IndexState.default_language]
                        + ': -' + Main.Instance.IndexState.shopItems[i].discount + ' %' :
                        Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Price + Main.Instance.IndexState.default_language]}
                    </span>
                    <span className = "info-price-xp">
                        {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Coins + Main.Instance.IndexState.default_language].toLowerCase()}
                    </span>
                </div>                
                <div className = "info-title">
                    {Main.Instance.IndexState.shopItems[i].title !== undefined ?
                    Main.Instance.IndexState.shopItems[i].title[Main.Instance.IndexState.default_language].trim().length > 0 ?
                    Main.Instance.IndexState.shopItems[i].title[Main.Instance.IndexState.default_language] : 
                    Main.Instance.IndexState.shopItems[i].title[0] : ''}
                </div>
                <div className = "info-content">
                    {getText(
                        Main.Instance.IndexState.shopItems[i].info[Main.Instance.IndexState.default_language].trim().length > 0 ?
                        Main.Instance.IndexState.shopItems[i].info[Main.Instance.IndexState.default_language] :
                        Main.Instance.IndexState.shopItems[i].info[0]
                        ,
                        false,
                        false
                    )}
                </div>
            </div>
        )
    }
    if (count === -1 && unlocks === false) shopItems.push (<img className = "comingsoon" key = "comingsoon" src = {Main.Instance.IndexState.images[Assets.ComingSoon]}/>)
    else if (unlocks === false) {
        if (countTotal !== Main.Instance.IndexState.countTotal) {

            Logic.Type.New (Main.Instance.IndexState, {
                pages: Math.ceil (countTotal / Assets.Items),
                countTotal
            })
        }
        if (Main.Instance.IndexState.pages > 1) {
            shopItems.push (
                <a
                    href = "javascript:void(0)"
                    onClick = {() => PageChange(false)}
                    key = "left"
                    className = "page-button"
                    // tslint:disable-next-line:max-line-length
                    style = {{marginTop: -srh/(5*2)+'px', fontSize: srh/5 + 'px', height:srh/4 + 'px', lineHeight:srh/5 + 'px', left: '5%', border: '0px', background: 'transparent', position: 'absolute', top: '50%', padding: '0px'}}
                >
                    {<FontAwesomeIcon style = {{lineHeight:srh/4 + 'px', fontWeight: 100}} icon = {faChevronLeft}/>}
                </a>
            )

            shopItems.push (
                <a
                    href = "javascript:void(0)"
                    onClick = {() => PageChange(true)}
                    key = "right"
                    className = "page-button"
                    // tslint:disable-next-line:max-line-length
                    style = {{marginTop: -srh/(5*2)+'px', fontSize: srh/5 + 'px', height:srh/4 + 'px', lineHeight:srh/5 + 'px', right: '5%', border: '0px', background: 'transparent', position: 'absolute', top: '50%', padding: '0px'}}
                >
                    {<FontAwesomeIcon style = {{lineHeight:srh/4 + 'px', fontWeight: 100}} icon = {faChevronRight}/>}
                </a>
            )
        }

    }
    return shopItems
}

function PageChange (right: boolean) {
    let page: number = Main.Instance.IndexState.page
    if (right) page++
    else page--
    if (page > Main.Instance.IndexState.pages) page = 1
    if (page === 0) page = Main.Instance.IndexState.pages
    Logic.Type.New (Main.Instance.IndexState, {page})
}

export function getShop (
    Category: number,
/*
    Password: string,
    PasswordIncorrect: boolean,
    Username: string,
    UsernameEmpty: boolean,
*/
    PointsXP: number
)
    : JSX.Element {

    if (!Main.Instance.IndexState.translation) return <div/>// Database Error</div>
    if (Main.Instance.IndexState.PLAYERID === 0 || Main.Instance.IndexState.PLAYERID === undefined) return <div/>// Error. Player ID is not defined.</div>

    // console.log (Main.Instance.IndexState.custom)

    return (
        <div className = "clearfix menucontent">        
            <ModalConfirmation
                height = "100px"
                width = "200px"
                isOpen = {Main.Instance.ModalState.NoBalanceError}
                r = "10px"
            >
                <div style = {{height:'100%',width:'100%',background:'#fff',position: 'relative',borderRadius:'10px'}}>
                {Main.Instance.IndexState.InfoConfirm2 ?
                    <span
                        style = {{
                            position: 'absolute',
                            top: '-25px',
                            left:'0px',
                            right:'-50px',
                            fontSize:'18px',
                            fontFamily: 'AvenirNextHeavy',
                            color: '#fff',
                        }}
                    >{
                    Main.Instance.IndexState.shopItems[Main.Instance.ModalState.BuyWhat].title[Main.Instance.IndexState.default_language].trim().length > 0 ?
                    Main.Instance.IndexState.shopItems[Main.Instance.ModalState.BuyWhat].title[Main.Instance.IndexState.default_language] :
                    Main.Instance.IndexState.shopItems[Main.Instance.ModalState.BuyWhat].title[0]
                    }
                    </span>
                    :
                    <React.Fragment>
                    <span
                        style = {{
                            position: 'absolute',
                            top: '10px',
                            left:'10px',
                            width:'180px',
                            fontSize:'12px',
                            fontFamily: 'AvenirNextHeavy',
                        }}
                    >
                    <FontAwesomeIcon style = {{marginRight: '5px', color: '#d9534f'}} size = "lg" icon = {faExclamationTriangle}/>
                    {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.NotificationOutOfPoints + Main.Instance.IndexState.default_language]}
                    </span>
                    <button
                        style = {{height: '24px', padding: '2px 7px', display: 'inline-block', position: 'absolute', bottom: '10px', left: '10px'}}
                        className = "btn btn-primary"
                        onClick = {() => NoBalanceErrorLeave()}
                    >
                        {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Ok + Main.Instance.IndexState.default_language].toUpperCase()}
                    </button>
                    <button
                        style = {{
                             height: '24px', padding: '2px 7px', display: 'inline-block',position: 'absolute', bottom: '10px', right: '10px'
                        }}
                        className = "btn btn-info"
                        onClick = {() => ToggleInfo2()}
                    >
                        T&amp;C
                    </button>
                    </React.Fragment>
                    }
                    {Main.Instance.ModalState.BuyWhat !== undefined && Main.Instance.IndexState.shopItems && Main.Instance.IndexState.InfoConfirm2 ?
                    <div className = {Main.Instance.IndexState.InfoConfirm2 ? 'Info-confirm-display' : 'Info-confirm'}>
                        <div className = {Main.Instance.IndexState.InfoConfirm2 ? 'info-confirm display' : 'info-confirm'}>
                            {getText(
                                    Main.Instance.IndexState.shopItems[Main.Instance.ModalState.BuyWhat].t_c[Main.Instance.IndexState.default_language].trim().length > 0 ?
                                    Main.Instance.IndexState.shopItems[Main.Instance.ModalState.BuyWhat].t_c[Main.Instance.IndexState.default_language] :
                                    Main.Instance.IndexState.shopItems[Main.Instance.ModalState.BuyWhat].t_c[0]
                                    ,
                                    false,
                                    false
                            )}
                            <a
                                href = "javascript:void(0)"
                                style = {{
                                    position: 'absolute', right: '-13px', top: '-8px',
                                    color: '#fff', background: 'transparent', border: '0px', fontSize: '16px'
                                }}
                                onClick = {() => SetInfoConfirm2False()}
                            >
                                <FontAwesomeIcon icon = {faTimesCircle}/>
                            </a>
                        </div>
                    </div> : void 0}

                </div>
            </ModalConfirmation>

            <ModalConfirmation
                height = "100px"
                width = "200px"
                isOpen = {Main.Instance.ModalState.Confirmation}
                r = "10px"
            >
                <div style = {{height:'100%',width:'100%',background:'#fff',position: 'relative',borderRadius:'10px'}}>
                    {Main.Instance.IndexState.InfoConfirm ?
                    <span
                        style = {{
                            position: 'absolute',
                            top: '-25px',
                            left:'0px',
                            right:'-50px',
                            fontSize:'18px',
                            fontFamily: 'AvenirNextHeavy',
                            color: '#fff',
                        }}
                    >{
                    Main.Instance.IndexState.shopItems[Main.Instance.ModalState.BuyWhat].title[Main.Instance.IndexState.default_language].trim().length > 0 ?
                    Main.Instance.IndexState.shopItems[Main.Instance.ModalState.BuyWhat].title[Main.Instance.IndexState.default_language] :
                    Main.Instance.IndexState.shopItems[Main.Instance.ModalState.BuyWhat].title[0]
                    }
                    </span>
                    :
                    <React.Fragment>
                    <span
                        style = {{
                            position: 'absolute',
                            top: '-25px',
                            left:'0px',
                            fontSize:'19px',
                            fontFamily: 'AvenirNextHeavy',
                            color: '#fff',
                            textTransform: 'uppercase'
                        }}
                    >
                        {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Balance + Main.Instance.IndexState.default_language]}
                    </span>

                    <span
                        style = {{
                            position: 'absolute',
                            top: '-25px',
                            right:'0px',
                            fontSize:'19px',
                            fontFamily: 'AvenirNextHeavy',
                            color: 'orange'
                        }}
                    >
                    {Main.Instance.IndexState.PointsXP}
                    <small>{' ' + Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Coins + Main.Instance.IndexState.default_language].toLowerCase()}</small>
                    </span>
                    </React.Fragment>}

                    <span
                        style = {{
                            position: 'absolute',
                            top: '5px',
                            left:'10px',
                            fontSize:'19px',
                            fontFamily: 'AvenirNextHeavy'
                        }}
                    >
                        {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.ConfirmPurchase + Main.Instance.IndexState.default_language]}
                    </span>

                    <span 
                        style = {{
                            position: 'absolute',
                            top: '28px',
                            left:'10px',
                            fontSize:'14px',
                            fontFamily: 'AvenirNextHeavy',
                            lineHeight: '18px'
                        }}
                    >
                        {!Main.Instance.IndexState.shopItems || Main.Instance.ModalState.BuyWhat === undefined ? '' :
                        Main.Instance.IndexState.shopItems[Main.Instance.ModalState.BuyWhat].title[Main.Instance.IndexState.default_language].trim().length > 0 ?
                        Main.Instance.IndexState.shopItems[Main.Instance.ModalState.BuyWhat].title[Main.Instance.IndexState.default_language] :
                        Main.Instance.IndexState.shopItems[Main.Instance.ModalState.BuyWhat].title[0]}
                    </span>
                    <span
                        style = {{
                            position: 'absolute',
                            top: '46px',
                            right:'10px',
                            fontSize:'14px',
                            fontFamily: 'AvenirNextHeavy',
                            color: 'red'
                        }}
                    >
                    {!Main.Instance.IndexState.shopItems || Main.Instance.ModalState.BuyWhat === undefined ? '' :
                    Main.Instance.IndexState.shopItems[Main.Instance.ModalState.BuyWhat].discountedPrice}
                    <small>{' ' + Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Coins + Main.Instance.IndexState.default_language].toLowerCase()}</small>
                    </span>

                    <button
                        style = {{
                             height: '24px', padding: '2px 7px', display: 'inline-block',marginLeft: '10px', marginTop: '65px'
                        }}
                        className = "btn btn-success"
                        onClick = {() => {
                            let proceed: boolean = true
                            if (Main.Instance.IndexState.shopItems[Main.Instance.ModalState.BuyWhat].multi.toString() === 'false' && Main.Instance.IndexState.allPlayerRst)
                            for (const item of Main.Instance.IndexState.allPlayerRst) {
                                if (item && item.idx === +Main.Instance.IndexState.shopItems[Main.Instance.ModalState.BuyWhat].id) {proceed = false; break}
                            }
                            if (proceed) {
                                StartAnimationBalance()
                                Cart_Buy(Main.Instance.ModalState.BuyWhat, Category)
                            }
                        }}
                    >
                        {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.ConfirmPurchase + Main.Instance.IndexState.default_language].split(' ')[0]}
                    </button>

                    <button
                        style = {{
                             height: '24px', padding: '2px 7px', display: 'inline-block',marginLeft: '9px', marginTop: '65px'
                        }}
                        className = "btn btn-info"
                        onClick = {() => ToggleInfo()}
                    >
                        T&amp;C
                    </button>

                    <button
                        style = {{
                            height: '24px', padding: '2px 7px', display: 'inline-block', marginLeft: '9px', marginTop: '65px'
                        }}
                        className = "btn btn-warning"
                        onClick = {() => ConfirmationLeave()}
                    >
                        {Main.Instance.IndexState.translation[Main.Instance.IndexState.languages.length * Assets.T.Cancel + Main.Instance.IndexState.default_language]}
                    </button>

                    {Main.Instance.ModalState.BuyWhat !== undefined && Main.Instance.IndexState.shopItems ?
                    <div className = {Main.Instance.IndexState.InfoConfirm ? 'Info-confirm-display' : 'Info-confirm'}>
                        <div className = {Main.Instance.IndexState.InfoConfirm ? 'info-confirm display' : 'info-confirm'}>
                            {getText(
                                    Main.Instance.IndexState.shopItems[Main.Instance.ModalState.BuyWhat].t_c[Main.Instance.IndexState.default_language].trim().length > 0 ?
                                    Main.Instance.IndexState.shopItems[Main.Instance.ModalState.BuyWhat].t_c[Main.Instance.IndexState.default_language] :
                                    Main.Instance.IndexState.shopItems[Main.Instance.ModalState.BuyWhat].t_c[0]
                                    ,
                                    false,
                                    false
                            )}
                            <a
                                href = "javascript:void(0)"
                                style = {{
                                    position: 'absolute', right: '-13px', top: '-8px',
                                    color: '#fff', background: 'transparent', border: '0px', fontSize: '16px'
                                }}
                                onClick = {() => SetInfoConfirmFalse()}
                            >
                                <FontAwesomeIcon icon = {faTimesCircle}/>
                            </a>
                        </div>
                    </div> : void 0}
                </div>
            </ModalConfirmation>

            <div className = "below">
                {Main.Instance.IndexState.RewardShopMode ? RstTable() :
                    getScandibetShop(
                        Category/*,
                        Password,
                        PasswordIncorrect,
                        Username,
                        UsernameEmpty,
                        PointsXP*/)}
            </div>
            <div className = "clearfix"/>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/Views/Main/Index/RewardShop.tsx